module.exports = __webpack_public_path__ + "img/4-5.18fd002b.svg";